import { flex } from '../../styles/mixins';
import styled from 'styled-components';

export const MinProgressWrap = styled.div`
	width: 122px;
	height: 30px;
	margin: 0 auto;
	${flex('row', 'center', 'center')}
	&:hover {
		background: #ebecf0;
		border-radius: 2px;
	}
`;
export const FishboneView = styled.div<{ minWidth: number; zoom?: number }>`
	${flex('row', 'center', 'center')}
	zoom: ${({ zoom }) => zoom || 100}%;
	.line {
		position: relative;
		${flex('row', 'end', 'center')}
		min-width: ${({ minWidth }) => minWidth}px;
		&:before {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			margin: auto;
			width: 100%;
			height: 2px;
			background-color: #7bb5ff;
		}
		> div {
			transform: translate(0px, calc(-50%));
			margin: 0 10px;
			width: 2px;
			height: 10px;
			background-color: #7bb5ff;
		}
	}
`;
export const FishbonePopView = styled.div`
	padding: 20px;
`;
